import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3q9hhadas: FaireProductEntity = {
  token: "p_b3q9hhadas",
  type: "product",
  name: "Magnesium Deodorant Stick | Coconut Creamsicle | 1 Pack",
  brandToken: "b_qpbga97kpu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0d1f670fd823970939c1bcefbf1ed1f6fe3ae038fdee8aa23488c9301de25a53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f95c3b3dc6359d30c2e997979159777d12626fb58c1fa0848642bf6bf6f03ef.jpeg",
    "https://cdn.faire.com/fastly/fda562df9e5b43b9a8837f2f2949f69abb594f1442b7594f6637aa04219dd15a.jpeg",
    "https://cdn.faire.com/fastly/cf467f295e893b73d92bcfda533d969c9937f46902212da1c2f8e41415259e5c.jpeg",
    "https://cdn.faire.com/fastly/a3a73085c18936ad558a370d1e6a11ce92523135542cb13e426c076d815cbdc7.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Fomin's Magnesium Deodorant Stick is a reflection of our ethos, 'All You Need Is Less'. \n\nThis product is more than just a hygiene item, it's a step towards a more eco-friendly lifestyle. Our vibrant packaging and natural scents make personal care a fun experience. Be part of the Fomin lifestyle, where cleaning is fun and sustainable.\n\nTop 5 Reasons You'll LOVE this:\n\n✅ Natural odor control without blocking sweat.\n\n✅ Helps keep skin’s pH balanced to stop odor before it starts.\n\n✅ Mineral-based, skin-friendly formula for safe daily use.\n\n✅ Moisturizing + calming for sensitive areas.\n\n✅ Smooth, non-greasy glide with a clean, silky finish.\n\nComes in Coconut Creamsicle, Sage Citrus, Melon Mist, Lavender Plum, and Rose Sandalwood.",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:12.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
